import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../Util/contexts/AppContext";
import MDSpinner from "react-md-spinner";

const FaqPage = ({ changeSettingsPage }) => {
  const { route, userData, displayAuthenticationError, primaryColor } =
    useContext(AppContext);
  const [faqQuestions, setFaqQuestions] = useState([]);
  const [faqLoading, setFaqLoading] = useState(true);

  useEffect(() => {
    fetch(`${route}/getfaq.webapi`, {
      method: "POST",
      headers: {
        Token: userData.Token,
        "Content-Type": "text/plain",
      },
    })
      .then(async (response) => {
        if (response.ok) {
          return response.json();
        } else if (response.status === 401) {
          return displayAuthenticationError();
        } else {
          throw new Error(await response.text());
        }
      })
      .then((data) => {
        setFaqQuestions(data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setFaqLoading(false);
      });
  }, [route, userData.Token, displayAuthenticationError]);

  return (
    <div className="accountSettingsBodyWrapper" id="FAQ" key="FAQ">
      <button
        className="accountSettingsBackButton tertiaryButton"
        onClick={() => changeSettingsPage("Settings")}
      >
        <FontAwesomeIcon
          icon={faArrowLeft}
          className="accountSettingsBackArrowIcon"
        />
        Back to Settings
      </button>
      <div className="accountSettingsCard accountSettingsBigCard">
        <h3 className="accountSettingsFaqQuestion">FAQ</h3>
        <p
          className="accountSettingsToggleDescription"
          style={{ marginBottom: 0 }}
        >
          Have a question about our software? We answer those here.
        </p>
      </div>
      {faqQuestions.map((question, index) => (
        <div
          className="accountSettingsCard accountSettingsBigCard"
          key={`FAQ Question - ${index + 1}`}
        >
          <h3 className="accountSettingsFaqQuestion">{question.question}</h3>
          <p className="accountSettingsFaqAnswer">{question.answer}</p>
          {question.image && (
            <img
              src={`${route}/images${question.image}`}
              alt={question.question}
              className="accountSettingsFaqImage"
            />
          )}
        </div>
      ))}
      {faqLoading && (
        <div className="accountSettingsLoadingWrapper">
          <MDSpinner size={50} singleColor={primaryColor} />
        </div>
      )}
    </div>
  );
};

export default FaqPage;
